import { useState, useEffect } from "react";

// Modul-Level-Cache für den Tenant-Slug — wird beim ersten Aufruf einmalig gelesen
let _tenantSlug: string | null = null;

function getTenantSlug(): string {
  if (_tenantSlug !== null) return _tenantSlug;
  try {
    _tenantSlug =
      document.querySelector<HTMLMetaElement>('meta[name="x-tenant-slug"]')?.content ?? "";
  } catch {
    _tenantSlug = ""; // SSR / Test-Umgebung ohne DOM
  }
  return _tenantSlug;
}

export function usePersistedState<T>(key: string, initial: T): [T, (val: T | ((prev: T) => T)) => void] {
  const slug = getTenantSlug();
  const scopedKey = slug ? `${slug}:${key}` : key;

  const [state, setState] = useState<T>(() => {
    try {
      const stored = sessionStorage.getItem(scopedKey);
      return stored ? (JSON.parse(stored) as T) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(scopedKey, JSON.stringify(state));
    } catch {
      // sessionStorage voll oder nicht verfügbar – ignorieren
    }
  }, [scopedKey, state]);

  return [state, setState];
}
